import React, {useState, useEffect, useRef} from "react";
import ColorChip from "../atoms/ColorChip";

const ColorChipList = ({
                         categoryName,
                         colorArray,
                         codeKeyData,
                         colorChipSelectHandler
                       }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const listRef = useRef(null);

  useEffect(() => {
    if (!isExpanded || !listRef.current) return;

    const container = listRef.current;
    const containerWidth = container.offsetWidth;

    const minGap = 6;
    const requiredWidth = (minGap * 4) + (58 * 5);

    if (requiredWidth > containerWidth) {
      const availableWidth = containerWidth - (minGap * 4);
      const adjustedItemWidth = availableWidth / 5;

      document.documentElement.style.setProperty('--item-width', `${(adjustedItemWidth / containerWidth) * 100}%`);
      container.style.gap = `${minGap}px`;
    } else {
      const remainingSpace = containerWidth - (58 * 5);
      const gap = remainingSpace / 4;

      document.documentElement.style.setProperty('--item-width', '20%');
      container.style.gap = `${Math.max(gap, minGap)}px`;
    }

    return () => {
      document.documentElement.style.removeProperty('--item-width');
    };
  }, [isExpanded, colorArray?.length]);

  const sortedColors = [...(colorArray || [])]
    .sort((a, b) => a.optionOrder - b.optionOrder)
    .filter(colorItem => colorItem.color.isActive);

  if (categoryName) {
    return (
      <div className={"option"}>
        <div className={"option-group"} data-expand={isExpanded}>
          <h2 onClick={() => setIsExpanded(!isExpanded)}>{categoryName}</h2>
          <ul className={"option-list"} ref={listRef}>
            {isExpanded && sortedColors.map((colorItem, index) => (
              <ColorChip
                key={index}
                codeKeyData={codeKeyData}
                colorItem={colorItem}
                colorChipSelectHandler={colorChipSelectHandler}
              />
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div className={"option"}>
      <ul className={"option-list"} ref={listRef}>
        {isExpanded && sortedColors.map((colorItem, index) => (
          <ColorChip
            key={index}
            codeKeyData={codeKeyData}
            colorItem={colorItem}
            colorChipSelectHandler={colorChipSelectHandler}
          />
        ))}
      </ul>
    </div>
  );
};

export default ColorChipList;
